import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.PRODUCT_PAGE]: {
    [ROLE.CONTAINER]: [
      ELEMENT.BUY_BOX_HEADER,
      ELEMENT.BUY_BOX_HEADER_FLAGS,
      ELEMENT.PRODUCT_RATING,
      ELEMENT.PRODUCT_CHARACTERISTICS,
      ELEMENT.PRODUCT_ENSEMBLE,
      ELEMENT.PRODUCT_ENSEMBLE_SKELETON,
      ELEMENT.PRODUCT_FRACTIONED,
      ELEMENT.PRODUCT_FREIGHT,
      ELEMENT.PRODUCT_PRICE,
      ELEMENT.QUESTION_SECTION,
      ELEMENT.QUESTION_ASK,
      ELEMENT.QUESTION_ITEM,
      ELEMENT.QUESTIONS_EMPTY,
      ELEMENT.ADD_TO_CART_BUTTONS_CONTAINER,
      ELEMENT.ADD_TO_CART_ACTIONS_CONTAINER,
      ELEMENT.AVAILABILITY_CONTAINER,
      ELEMENT.SKELETON,
      ELEMENT.ACTION_BOX,
      ELEMENT.INPUT_STEPPER,
      ELEMENT.PRODUCT_SELLER_REPUTATION,
      ELEMENT.PRODUCT_VARIANT_SELECTOR,
      ELEMENT.PRODUCT_OUT_OF_STOCK,
      ELEMENT.PRODUCT_UNAVAILABLE,
      ELEMENT.COLOR_ATTRIBUTES,
      ELEMENT.CHIPS_ATTRIBUTES,
      ELEMENT.THUMBS_ATTRIBUTES,
      ELEMENT.SERVICES,
      ELEMENT.WARRANTY,
      ELEMENT.PRODUCT_INFORMATION,
      ELEMENT.PRODUCT_CHARACTERISTICS,
      ELEMENT.SEE_MORE,
      ELEMENT.PRODUCT_RATING_AND_REVIEWS,
      ELEMENT.PRODUCT_COUNTDOWN,
      ELEMENT.PRODUCT_COUPON,
      ELEMENT.PRODUCT_CLOCK,
      ELEMENT.ADD_SERVICES_TO_PRODUCT,
      ELEMENT.ADDED_SERVICES,
      ELEMENT.PRODUCT_INFO,
      ELEMENT.PRICE_INFO,
      ELEMENT.SERVICE_ITEMS,
      ELEMENT.WARRANTY_SECTION,
      ELEMENT.MADEIRA_ORIGINALS,
      ELEMENT.PURCHASE_ALL,
      ELEMENT.PURCHASE_ALL_DIALOG_CONTENT,
      ELEMENT.PURCHASE_ALL_DIALOG_CONTENT_SKELETON,
      ELEMENT.PURCHASE_ALL_DIALOG_PRODUCTS,
      ELEMENT.PURCHASE_ALL_DIALOG_RESUME,
      ELEMENT.FREIGHT_FLAG,
      ELEMENT.BUY_BOX_SELECTOR,
    ],
    [ROLE.CARD]: [
      ELEMENT.WARRANTY_BOX,
      ELEMENT.BANNER_SERVICE,
      ELEMENT.SERVICE_ITEM,
      ELEMENT.PURCHASE_ALL_DIALOG_PRODUCT_CARD,
      ELEMENT.BUY_BOX_SELLER_OFFER,
    ],
    [ROLE.DIALOG]: [
      ELEMENT.WARRANTY_DIALOG,
      ELEMENT.ADD_SERVICES_DIALOG,
      ELEMENT.CART_SUMMARY_DIALOG,
      ELEMENT.VOLTAGE_DIALOG,
      ELEMENT.PURCHASE_ALL_DIALOG,
    ],
    [ROLE.BUTTON]: [
      ELEMENT.ADD_SERVICE,
      ELEMENT.DIALOG_CLOSE_BUTTON,
      ELEMENT.ADD_TO_CART_BUTTON,
      ELEMENT.BUY_BUTTON,
      ELEMENT.BACK_TO_TOP,
    ],
    [ROLE.LINK]: [ELEMENT.SEE_MORE_SELLER_PRODUCTS],
  },
  [CONTEXT.PRODUCT_DETAIL_DIALOG]: {
    [ROLE.CONTAINER]: [
      ELEMENT.PRODUCT_ENSEMBLE_DIALOG_CONTENT,
      ELEMENT.PRODUCT_ENSEMBLE_DIALOG_FOOTER,
    ],
  },
  [CONTEXT.PRODUCT_INFORMATION]: {
    [ROLE.BUTTON]: [ELEMENT.SEE_MORE],
    [ROLE.CONTAINER]: [ELEMENT.PRODUCT_DESCRIPTION, ELEMENT.PRODUCT_CHARACTERISTICS],
  },
  [CONTEXT.PRODUCT_DESCRIPTION]: {
    [ROLE.CONTAINER]: [ELEMENT.PRODUCT_INFORMATION, ELEMENT.DIALOG_CONTENT],
    [ROLE.BUTTON]: [ELEMENT.SEE_MORE],
  },
  [CONTEXT.PRODUCT_CHARACTERISTICS]: {
    [ROLE.BUTTON]: [ELEMENT.SEE_MORE, ELEMENT.SEE_MORE_CHARACTERISTICS],
  },
  [CONTEXT.PRODUCT_DESCRIPTION_DIALOG]: {
    [ROLE.CONTAINER]: [ELEMENT.DIALOG_CONTENT],
  },
  [CONTEXT.PRODUCT_CHARACTERISTICS_DIALOG]: {
    [ROLE.CONTAINER]: [ELEMENT.DIALOG_CONTENT],
  },
  [CONTEXT.PRODUCT_RATING_AND_REVIEWS]: {
    [ROLE.CONTAINER]: [ELEMENT.FILTERS],
    [ROLE.LIST]: [ELEMENT.REVIEWS],
  },
  [CONTEXT.PRODUCT_FREIGHT_DIALOG]: {
    [ROLE.CONTAINER]: [ELEMENT.DIALOG_CONTENT],
  },
  [CONTEXT.PRODUCT_PAYMENT_METHODS_DIALOG]: {
    [ROLE.CONTAINER]: [
      ELEMENT.PRODUCT_PAYMENT_METHODS_DIALOG_CONTENT,
      ELEMENT.PRODUCT_PAYMENT_METHODS_DIALOG_FOOTER,
    ],
  },
  [CONTEXT.PRODUCT_FREIGHT]: {
    [ROLE.CONTAINER]: [ELEMENT.FREIGHT_CALCULATED, ELEMENT.FREIGHT_UNAVAILABLE],
  },
  [CONTEXT.PRODUCT_SHOWCASE]: {
    [ROLE.CONTAINER]: [
      ELEMENT.SHOWCASE_BOTTOM_BLOCK,
      ELEMENT.SHOWCASE_MID_BLOCK,
      ELEMENT.SHOWCASE_TOPBLOCK,
      ELEMENT.SHOWCASE_TOP_BLOCK_WITHOUT_BUY_TOGETHER,
      ELEMENT.SHOWCASE_SAME_COLLECTION,
    ],
    [ROLE.DIALOG]: [ELEMENT.SHOWCASE_DIALOG],
  },
  [CONTEXT.PRODUCT_REVIEW_SUMMARY]: {
    [ROLE.CONTAINER]: [ELEMENT.REVIEW_SUMMARY],
  },
} as TValidTestId;
